// import React, { useEffect, useState } from "react";
// import PageLoader from "./PageLoader";
// import { useAuth } from "./../util/auth";
// import { useRouter } from "./../util/router";
// import { redirectToBilling } from "./../util/stripe";

// function SettingsBilling(props) {
//   const router = useRouter();
//   const auth = useAuth();
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     if (auth.user.stripeCustomerId) {
//       // If user has an active plan then
//       // take them to Stripe billing
//       redirectToBilling().catch((error) => {
//         setLoading(false);
//         props.onStatus({
//           type: "error",
//           message: error.message,
//         });
//       });
//     } else {
//       // Otherwise go to pricing so they can
//       // purchase a plan
//       router.replace("/pricing");
//     }

//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, []);

//   return <>{loading && <PageLoader height={50} />}</>;
// }

// export default SettingsBilling;

import React, { useEffect, useState } from "react";
import PageLoader from "./PageLoader";
import { useAuth } from "./../util/auth";
import { useRouter } from "./../util/router";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Button from "@material-ui/core/Button";

function SettingsBilling(props) {
  const router = useRouter();
  const auth = useAuth();
  const [loading, setLoading] = useState(true);
  const [showUnsubscribeConfirm, setShowUnsubscribeConfirm] = useState(false);
  const [isUnsubscribing, setIsUnsubscribing] = useState(false);

  useEffect(() => {
    if (auth.user?.stripeCustomerId) {
      // If user has an active plan, show unsubscribe option
      setLoading(false);
    } else {
      // Otherwise go to pricing so they can purchase a plan
      router.replace("/pricing");
    }
  }, [auth.user, router]);

  const handleUnsubscribeConfirm = async () => {
    if (!auth.user || !auth.user.stripeCustomerId) {
      console.error("User not authenticated or missing Stripe customer ID.");
      setShowUnsubscribeConfirm(false);
      return;
    }

    setIsUnsubscribing(true);
    try {
      const response = await fetch("/api/stripe-cancel-subscription", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ stripeCustomerId: auth.user.stripeCustomerId }),
      });

      const data = await response.json();

      if (response.ok) {
        console.log("Subscription cancelled successfully:", data);
        router.push("/"); // Redirect after successful unsubscribe
      } else {
        console.error("Error cancelling subscription:", data);
        props.onStatus({
          type: "error",
          message: "Failed to cancel subscription. Please try again.",
        });
      }
    } catch (error) {
      console.error("Failed to cancel subscription:", error);
    } finally {
      setIsUnsubscribing(false);
      setShowUnsubscribeConfirm(false);
    }
  };

  return (
    <>
      {loading ? (
        <PageLoader height={50} />
      ) : (
        <div
          className="billing-section"
          style={{ textAlign: "center", marginTop: "40px" }}
        >
          <h2>Your subscription is active</h2>
          <p>
            You can unsubscribe anytime. You will lose access to premium
            features at the end of your billing period.
          </p>
          <Button
            variant="contained"
            color="error"
            onClick={() => setShowUnsubscribeConfirm(true)}
          >
            Unsubscribe
          </Button>
        </div>
      )}

      {/* Unsubscribe Confirmation Dialog */}
      <Dialog
        open={showUnsubscribeConfirm}
        onClose={() => setShowUnsubscribeConfirm(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Are you absolutely sure?"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            This action cannot be undone. This will cancel your current
            subscription and you will lose access to premium features at the end
            of your billing period. Your remaining credits will be set to 0.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setShowUnsubscribeConfirm(false)}
            color="primary"
            disabled={isUnsubscribing}
          >
            Cancel
          </Button>
          <Button
            onClick={handleUnsubscribeConfirm}
            color="error"
            autoFocus
            disabled={isUnsubscribing}
          >
            {isUnsubscribing ? "Unsubscribing..." : "Confirm Unsubscribe"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default SettingsBilling;
